import i18n from 'i18n-js';

import { translations } from '@aps-management/primapp-common';

i18n.locale = 'fr'; // Localization.locale;
i18n.fallbacks = true;
i18n.defaultLocale = 'fr';
i18n.translations = translations;

/* */
i18n.getFromOpts = (scope, opts, params) => {
  if (params && typeof params.activity !== 'undefined') {
    const translation = opts.activities[params.activity]?.scopes[scope];
    if (translation) {
      return translation;
    }
  } else {
    const translation = opts.i18n?.[scope];
    if (translation) return translation;
  }

  return i18n.t(scope);
};

/* */
// Une clé "code" (ex: errors.account.not_found, R123) qui n'a aucune traduction
// ne doit jamais s'afficher brute à l'utilisateur : on tente la résolution via
// un sentinel de contrôle, et si elle échoue, on bascule sur le message générique.
const CODE_LIKE = /^[a-z][a-z0-9_.]*$/i;
i18n.t = (str, opts = {}) => {
  if (typeof str !== 'string' || !CODE_LIKE.test(str) || str.includes(' ')) {
    return i18n.translate(str, { defaultValue: str, ...opts });
  }
  const result = i18n.translate(str, { defaultValue: '__I18N_MISSING__', ...opts });
  return result === '__I18N_MISSING__'
    ? i18n.translate('errors.generic_fallback', {
        defaultValue: 'Une erreur est survenue. Réessayez ou contactez le support.',
      })
    : result;
};

export default i18n;
